<template>
    <div :class="{'virtual-page': isVirtualPage}">
        <nav class="main-nav">
                       
            <div v-if="data.stripped === false" class="menu-toggle" @click="toggle(1)">
                <div class="burger-icon" :class="{ open : is_toggled == 1 }">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>

            <div class="container container--nav">
                <a href="/" class="logo--main" aria-label="Colorsteel" title="Colorsteel">
                    <img v-if="data.logoHeader" :src="data.logoHeader" alt="Colorsteel Logo">
                </a>
                <div class="menu" :class="{ open : is_toggled == 1 }">
                    <div class="mobile-bottom-background"></div>
                    <ul v-if="data.stripped === false">

                        <li
                            v-for="(link, index) in data.links"
                            :key="index"
                            :class="`${link.ShowChildren ? 'main-menu-item with-megamenu' : 'main-menu-item'}`"
                        >
                            <div v-if="link.ShowChildren" @click="activate(link.id)" class="menu-link mega-menu-link" :class="{ active : active_menu == link.id }">
                                {{link.title}}
                                <span class="underline"></span>
                            </div>


                            <ul v-if="link.ShowChildren" class="mega-menu" :class="{ active : active_menu == link.id }">
                                <li class="menu-list" 
                                    :class="{faded : (hoveredItem!==null && hoveredItem!==index)}" 
                                    v-for="(child, index) in link.Children" 
                                    :key="index"
                                >
                                    <a class="menu-list-link" 
                                        :href="child.link" 
                                        aria-label="" 
                                        title=""

                                        @mouseover="itemHoverIn(index)"
                                        @mouseout="itemHoverOut()"
                                    >
                                        <p class="title">{{child.title}}</p>
                                        <span class="menu-link-summary" v-html="child.summary"></span>
                                    </a>
                                </li>
                            </ul>

                            <a v-if="!link.ShowChildren" :href="link.link" class="menu-link" aria-label="" :title="link.title">
                                {{link.title}}
                                <span class="underline"></span>
                            </a>
                        </li>

                        <li class="contact-button">
                            <a :href="data.contact" class="menu-link menu-icon menu-icon--contact" aria-label="Contact us" title="Contact us"></a>
                            <a :href="data.contact" class="menu-text-contact" aria-label="Contact us" title="Contact us">Contact us</a>
                        </li>
                        <li class="separator-mobile"></li>
                        <li class="search-button">
                            <a :href="data.search" class="menu-link menu-icon menu-icon--search" aria-label="Search" title="Search"></a>
                            <a :href="data.search" class="menu-text-search" aria-label="Search" title="Search">Search</a>
                            
                        </li>

                        <li class="logo-button">
                            <a href="/" class="logo--mobile" aria-label="Colorsteel" title="Colorsteel"></a>

                        </li>

                    </ul>
                    <ul v-else class="">
                        <li>
                            <a @click="previousUrl" class="menu-link menu-icon menu-icon--close" aria-label="Go back" title="Go back"></a>
                        </li>
                    </ul>
                </div>
                <a v-if="data.stripped === true" @click="previousUrl" class="close-mobile" aria-label="Go back" title="Go back"></a>

                <!-- display only on virtual page -->
                <div v-if="isVirtualPage" class="close" @click="closeClickHandler">
                    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M19.2462 18L27 25.7538L25.7538 27L18 19.2462L10.2462 27L9 25.7538L16.7538 18L9 10.2462L10.2462 9L18 16.7538L19.2462 18Z" fill="#2D2C2C"/>
                        <rect x="25.7582" y="8.99933" width="1.75348" height="9.85034" transform="rotate(45 25.7582 8.99933)" fill="#2D2C2C"/>
                    </svg>
                </div>
            </div>
        </nav>

        <div class="nav--overlay" :class="{novis: active_menu<=0}"  @click="closeMegamenuNow()"></div>

    </div>
</template>

<script>
// import { Fragment } from 'vue-fragment';
import {Toggle} from "../../elements";
// import { PersonaFull } from "../../components/PersonaFull";
import PersonaFull from '../PersonaFull';
import bus from '../../utilities/eventbus';

export default {
    name: "v-navigation",
    components: {
        // Fragment,
        Toggle,
        PersonaFull
        // ModalFullpage
    },
    props: {
        data: {
            type: Object
        }
    },
    data () {
        return {
            stripped: false,
            active_menu: 0,
            is_toggled: 0,
            actionCount: 0,
            actionVisited: 0,
            actionVisitedList: [],
            hoveredItem: null,
            notificationItems: null,
            personaKey : null,
            personaCookie: null,
            isVirtualPage: false,
        }
    },
    methods: {
        activate(el) {
            //this.active_menu = el;
            //this.active_menu = this.active_menu === index ? null : index;

            if ( this.active_menu == el )
            {
                this.active_menu = 0;
            }
            else
            {
                this.active_menu = el;
            }
        },
        toggle(el) {
            //this.is_toggled = !this.is_toggled;

            if ( this.is_toggled == el )
            {
                this.is_toggled = 0;
            }
            else
            {
                this.is_toggled = el;
            }
        },
        previousUrl() {
            this.linkOverlayNavigateBack();
            // window.history.go(-1)
        },
        showPersonaModal() {
            this.$refs.personaFull.showPersonaModal();
            this.closeMegamenuNow();
        },
        itemHoverIn(index){
            this.hoveredItem = index;
        },
        itemHoverOut(){
            this.hoveredItem = null;
        },
        closeMegamenuNow(){
            this.active_menu = 0;
        },
        loadNotificationCookie() {
            let notificationItemsString = this.$cookies.get('notificationItems');
            this.notificationItems = notificationItemsString;
        },
        visitPersonaAction(url) {
            let cookieData = this.getVisitedPersonaLinks(false);
            
            if( cookieData.current.data.links.indexOf(url)<0 ){
                cookieData.current.data.links.push(url);
            }

            if(cookieData.current.idx===null){
                cookieData.cookie.push(cookieData.current.data);
            }else{
                cookieData.cookie[cookieData.current.idx] = cookieData.current.data;
            }

            this.$cookies.set('visitedPersonaActions', JSON.stringify(cookieData.cookie));
            this.actionVisited = cookieData.current.data.links.length;
            this.actionVisitedList = cookieData.current.data.links;
        },
        getVisitedPersonaLinks(refreshCount){
            let cookie = this.$cookies.get('visitedPersonaActions');
            if(cookie===null) cookie = '[]';
            let cookieArr = JSON.parse(cookie);
            let current = {
                idx: null,
                data: {
                    key: this.personaKey,
                    links: []
                }
            }
            
            cookieArr.forEach((data,idx) => {
                if(data.key===this.personaKey){
                    current = {
                        idx: idx,
                        data: data
                    }
                }
            });

            if(refreshCount){
                this.actionVisited = current.data.links.length;
                this.actionVisitedList = current.data.links;
            }

            return {
                cookie : cookieArr,
                current : current
            }
        },
        slugify(string) {
            if(typeof string !== 'string') return false;

            const title = string.toLowerCase().split(' ').map(function(word) {
                return (word.charAt(0).toUpperCase() + word.slice(1));
            }).join(' ');

            const slug = title
                .toString()
                .trim()
                .replace(/\s+/g, "-")
                .replace(/[^\w\-]+/g, "")
                .replace(/\-\-+/g, "-")
                .replace(/^-+/, "")
                .replace(/-+$/, "")
                .replace(/\-+/g, "");

            return slug;
        },
        closeClickHandler() {
            this.linkOverlayNavigateBack();
        },
        virtualPageCheck() {
            const currentUrlString = window?.location?.href || ''
            const virtualPages = ['/inspiration/mood-board/']
            let currentUrl = null
            let pathname = ''

            if (currentUrlString) {
                currentUrl = new URL(currentUrlString)
                pathname = currentUrl.pathname
            }

            return virtualPages.includes(pathname)
        },
    },
    mounted(){
        if (this.virtualPageCheck()) {
            this.isVirtualPage = true;
        }

        this.loadNotificationCookie();

        this.personaKey = this.slugify(this.personaCookie);
        this.actionCount = this.data.currentPersonaRelatedLinks ? this.data.currentPersonaRelatedLinks.length : 0;
        this.getVisitedPersonaLinks(true);
    },
    created() {
        this.personaCookie = this.$cookies.get('Persona');
        bus.$on('notifAdded', this.loadNotificationCookie);
    }
};
</script>

<style lang="scss" scoped>
@import "../../../scss/abstracts/variables";
@import "../../../scss/abstracts/mixins";

$desktopAndUp: $desktopMenuStart;
$belowDesktop: $desktopMenuEnd;
$logoSizeBreakpoint: #{'only screen and (min-width: 1300px)'};

.font-medium {
    font-family: $font-primary-med;
}

.profile-links {
    border-bottom: solid 1px rgba(45,44,44,0.2);
    position: fixed;
    background: #FFFEFA;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 1999;
    @include font-size(12);

    .container {
        display: flex;
        min-height: 60px;

        @media (max-width:1199px) {
            width: 100%;
            overflow-y: scroll;
        }
    }

    span,
    a {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 50px;
        white-space: nowrap;

        @media (max-width:1199px) {
            margin-right: 30px;
        }
    }

    span {
        font-family: $font-primary-med;
    }

    a {
        opacity: 0.5;
        transition: all 300ms;

        &:hover {
            opacity: 1;
        }
    }
}

.mobile-persona-selector {
    width: 30px;
    height: 30px;
    display: block;
    background-size: 30px;
    background-position: center;
    background-repeat: no-repeat;
    position: fixed;
    z-index: 99999;
    background-image: url('#{$dir-images}icons/profile-large.svg');
    top: 26px;
    right: 70px;
    cursor: pointer;

    //  @media #{$belowDesktop} {
    //         z-index: 0;
    // }


    @media #{$desktopAndUp} {
        display: none;
    }

    .notice {
        position: absolute;
        right: -5px;
        top: -2px;
        background-color: #2D2C2C;
        color: #FFFEFA;
        font-size: 8px;
        line-height: 14px;
        font-weight: bold;
        border-radius: 20px;
        padding: 0 4px;

        @media #{$belowDesktop} {
            visibility: hidden;
        }

        @media #{$desktopAndUp} {
            visibility: visible;
        }

        // @media #{$belowDesktop} {
        //    display:none;
        // }

    }
}

.main-nav {
    position: absolute;
    display: block;
    width: 100%;
    z-index: 999;
    top: 0;

    .menu-toggle {
        position: fixed;
        display: block;
        top: 30px;
        right: 20px;
        cursor: pointer;
        font-size: 24px;
        height: 30px;
        width: 30px;
        z-index: 99999;

        @media #{$desktopAndUp} {
            display: none;
        }

        .burger-icon {
            width: 30px;
            height: 30px;
            position: relative;
            transform: rotate(0deg);
            transition: .5s ease-in-out;
            cursor: pointer;

            span {
                display: block;
                position: absolute;
                height: 2px;
                width: 100%;
                background: $color-primary;
                border-radius: 10px;
                opacity: 1;
                left: 0;
                transform: rotate(0deg);
                transition: .25s ease-in-out;

                &:nth-child(1) {
                    top: 0;
                }

                &:nth-child(2) {
                    top: 10px;
                }

                &:nth-child(3) {
                    top: 10px;
                }

                &:nth-child(4) {
                    top: 20px;
                }
            }

            &.open {

                  @media #{$belowDesktop} {
                       
                        position:fixed;
                        height: 25px;
                        width:25px;
                  }


                span {
                    background: $color-primary;

                    &:nth-child(1) {
                        top: 18px;
                        width: 0;
                        left: 50%;
                    }

                    &:nth-child(2) {
                        transform: rotate(45deg);
                    }

                    &:nth-child(3) {
                        transform: rotate(-45deg);
                    }

                    &:nth-child(4) {
                        top: 18px;
                        width: 0;
                        left: 50%;
                    }
                }
            }
        }
    }

    .container--nav {
        position: relative;
        display: block;

        @media #{$desktopAndUp} {
            justify-content: space-between;
            height: 130px;
            align-items: center;
            display: flex;
        }

        .logo--main {
            display: block;
            position: relative;
            z-index: inherit;
            top: 1rem;
            text-decoration: none;

            /** BASE LOGO SIZE */
            aspect-ratio: 214 / 50;
            width: 270px;

            @media #{$desktopAndUp} {
                top: 0;
                z-index: 1;
            }

            @media #{$logoSizeBreakpoint} {
                z-index: 1;
                // top: 0;
                // height: 65px;
                // width: 280px;
                width: 340px;
            }

            img {
                max-width: 100%;
                max-height: 100%;
            }
        }

        .menu {
            display: block;
            position: fixed;
            background: $brand-blue;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            padding: 4rem 3rem;
            transform: translate(100%, 0);
            transition: all 500ms;

            @media #{$desktopAndUp} {
                display: block;
                position: absolute;
                background: transparent;
                padding: 0;
                transform: translate(0, 0);

                left: $grid-gutter-base;
                right: $grid-gutter-base;
                width: auto;
            }

            ul {
                height: 130px;
                flex-direction: row;
                justify-content: flex-end;
                align-items: center;
                margin: 0;
                padding: 0;
                list-style-type: none;

                @media #{$desktopAndUp} {
                    display: flex;
                }

                &.persona-menus {
                    li {
                        width: 100%;
                        font-size: 10px;

                        .menu-list-link {
                            font-size: 10px !important;

                            span {
                                font-size: 10px !important;
                            }
                        }
                    }
                }

                li {
                    margin: 2rem 0;
                    padding: 0;

                    @media #{$desktopAndUp} {
                        margin: 0;
                    }

                    .notification-list {
                        display: block;
                        height: auto;
                        margin-top: 10px;
                        padding-top: 10px;
                        border-top: solid 1px rgba(45,44,44,0.2);

                        li {
                            white-space: nowrap;
                        }
                    }

                  

                    .menu-link {
                        font-family: $font-primary-med;
                        position: relative;
                        line-height: 25px;
                        display: block;
                        
                        // font-size: 18px;
                        // @include font-size(14);
                        @include font-size(16);

                        text-decoration: none;
                        margin-left: 0;
                        cursor: pointer;

                        @media #{$desktopAndUp} {
                            margin-left: 40px;
                        }

                        &.mega-menu-link {
                            position: relative;
                            padding-right: 25px;


                             @media #{$belowDesktop} {
                                transition: none;
                             }


                            &::before {
                                visibility: hidden;
                                opacity: 0;
                                content: "";
                                display: block;
                                position: absolute;
                                left: 50%;
                                bottom: -60px;
                                width: 0;
                                height: 0;
                                border: 20px solid transparent;
                                border-bottom-color: #FBF7F1;
                                border-top: 0;
                                margin-left: -20px;
                                margin-top: -20px;
                                transition: all 500ms;
                            }

                            &::after {
                                content: '';
                                display: block;
                                position: absolute;
                                top: 5px;
                                right: 0;
                                height: 16px;
                                width: 16px;
                                background-size: 14px;
                                background-position: center;
                                background-repeat: no-repeat;
                                background-image: url('#{$dir-images}icons/down-simple.svg');
                                transform: rotate(0);
                                transition: all 500ms;

                                @media only screen and (max-width: 1199px) {
                                    transition: none;
                                    display:inline-block;
                                    right:auto;
                                    margin-left:10px;
                                    transform:rotate(270deg);
                                }

                            }

                            &.active {
                                &::before {
                                    visibility: visible;
                                    opacity: 1;
                                    bottom: -45px;
                                }
                                &::after {
                                    transform: rotate(180deg);
                                }



                                @media #{$belowDesktop} {
                                    
                                    z-index: 100;
                                    position: fixed;
                                    top: 0px;
                                    left: $outer-container-margin;
                                    padding-left: 20px;
                                    padding-bottom: 20px;
                                    padding-top:28px;
                                    background: #C4DBEB;
                                    width: calc( 100vw - #{$outer-container-margin} );

                                        &::before {
                                                display: none;
                                        }

                                        &::after{
                                                left: 0;
                                                top:32px;
                                                transform: rotate(90deg);
                                                margin-left:0;
                                        }

                                }




                            }


                            &.mega-menu-link-single {
                                &::before {
                                    bottom: -60px;
                                }

                                &.active {
                                    &::before {
                                        bottom: -34px;
                                    }
                                }
                            }
                        }

                        &.menu-icon {
                            width: 44px;
                            height: 44px;
                            display: block;
                            background-size: 18px;
                            background-position: center;
                            background-repeat: no-repeat;
                            position: relative;

                            &.menu-icon--contact {
                                margin-left: 20px;
                                background-image: url('#{$dir-images}icons/phone.svg');
                            }

                            &.menu-icon--search {
                                margin-left: 0;
                                background-image: url('#{$dir-images}icons/search.svg');
                            }

                            &.menu-icon--profile {
                                background-size: 44px;
                                margin-left: 10px;
                                background-image: url('#{$dir-images}icons/profile-large.svg');

                                // &::before,
                                &::after {
                                    display: none !important;
                                }
                            }

                            &.menu-icon--close {
                                background-image: url('#{$dir-images}icons/close.svg');
                            }
                        }
                    }

                    .notice {
                        display: block;
                        position: absolute;
                        right: 0;
                        z-index: 99;
                        background-color: $color-primary;
                        color: $brand-white;
                        width: 18px;
                        height: 18px;
                        text-align: center;
                        border-radius: 10px;
                        font-size: 10px;
                        line-height: 18px;
                        font-weight: bold;
                    }

                    // Target mega menu
                    // ============

                    .mega-menu {
                        visibility: hidden;
                        opacity: 0;
                        display: flex;
                        flex-direction: row;
                        justify-content: flex-start;
                        align-items: flex-start;
                        flex-wrap: wrap;
                        position: absolute;
                        width: calc(100% - 120px);
                        left: 120px;
                        top: 135px;
                        margin: 0;
                        list-style-type: none;
                        z-index: 99;
                        background-color: $color-megamenu-bg;
                        height: auto;
                        transition: all 500ms;
                        padding: 30px;


                       
                         @media #{$belowDesktop} {
                            position: fixed;
                            left: 100vw;
                            top: 0;
                            height:100vh;
                            background-color:transparent;
                            width:100vw;

                        }



                        .menu-list {
                            padding: 35px;
                            list-style-type: none;
                            margin: 0;
                            width: 33.3333%;
                            transition: all 300ms;
                            

                             @media #{$belowDesktop} {
                                
                                  width: 100%;
                                  padding-bottom:0px;
                                  padding-top:20px;

                                  &:first-child{
                                      padding-top:35px;

                                  }

                            }

                            

                            &.faded {
                                opacity: 0.5;
                            }

                            .menu-list-link {
                                display: block;
                                margin: 0;
                                // font-weight: bold;
                                position: relative;
                                cursor: pointer;

                                p.title {
                                    font-family: $font-primary-med;
                                    font-size: 14px;
                                    margin-top: 0;
                                    margin: 0 0 10px 0;
                                }

                                // &:hover{                                    
                                //     .menu-link-summary{
                                //         opacity: 0;

                                //         &.alt {
                                //             opacity: 1;
                                //         }
                                //     }
                                // }
                            }

                            .menu-link-summary{
                                font-family: $font-primary;
                                font-weight: normal;
                                transition: all 300ms;
                                display: block;
                                opacity: 1;

                                &.alt {
                                    font-weight: bold;
                                    position: absolute;
                                    left: 0;
                                    bottom: 0;
                                    width: 100%;
                                    opacity: 0;
                                }
                            }

                            span {
                                font-size: 14px;
                            }
                        }

                        @media #{$belowDesktop} {
                            padding-top: 4rem;
                        }
                        &.active {
                            visibility: visible;
                            opacity: 1;
                            top: 120px;



                             @media #{$belowDesktop} {

                                   position: fixed;
                                   top: 0;
                                   left: 0;
                                    width: 100vw;
                                    height: 100vh;
                                    background-color:#C4DBEB;
                                    display:block;
                                    overflow-y:scroll;

                            }

                          


                        }

                        &.mega-menu-single {
                            max-width: 200px;
                            left: inherit;
                            right: 0;

                            &.persona-menus {
                                padding: 20px;
                            }

                            .menu-list {
                                padding: 0;
                                width: 100%;
                            }
                        }
                    }
                }
            }

            &.open {
                transform: translate(0, 0);
            }
        }
    }
}

.nav--overlay {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 900;
    display: none;
    
    @media #{$desktopAndUp} {
        display: block;
    }

    &.novis {
        display: none;
    }
}

.menu-text-search{
    display:block;
    width:90px;
    text-align:center;
    @media #{$desktopAndUp} {
        display:none;

    }

}

.menu-text-contact{
    display:block;
    width:90px;
    text-align:center;
    @media #{$desktopAndUp} {
        display:none;

    }

}

// fix for mobile search and contact

.main-nav .container--nav .menu ul li .menu-link.menu-icon.menu-icon--contact {
    height:50px;
    width:90px;
    background-size:40px;
    margin-left: 0;

    @media #{$desktopAndUp} {
        background-size:18px;
        height:44px;
        width:44px;
        margin-left:20px;

    }


}

.main-nav .container--nav .menu ul li .menu-link.menu-icon.menu-icon--search {
    height:50px;
    width:90px;
    background-size:40px;
    margin-left: 0;

    @media #{$desktopAndUp} {
        background-size:18px;
        height:44px;
        width:44px;
        margin-left:0;
    }


}

.profile-button{
    @media #{$belowDesktop} {
        display:none;

    }


}


.logo--mobile {
            display: block;
            position: absolute;
            z-index: inherit;
            width: 165px;
            height: 33px;
            top: 24px;
            left: $outer-container-margin; 


            background-image: url('#{$dir-images}logos/colorsteel.svg');
            background-size: 100%;
            background-position: center;
            background-repeat: no-repeat;
            text-decoration: none;
            

            @media #{$desktopAndUp} {
                display:none;
            }


}


.search-button{
    position: absolute;
    bottom: -15px;
    left: calc(25vw - 45px);

    @media #{$desktopAndUp} {
        position:inherit;
        right: auto;
        bottom: auto;
    }


}

  .separator-mobile{
        display:none;


        @media #{$belowDesktop} {
            display:block;
            width:1px;
            background: $brand-blue;
            height: 100px;
            position: absolute;
            bottom: -32px;
            left:50vw;

        }

    }

.contact-button{
    position: absolute;
    bottom: -15px;
    right: calc(25vw - 45px);

    @media #{$desktopAndUp} {
        position:inherit;
        right: auto;
        bottom: auto;
    }

}

.mobile-bottom-background{
    background: #FFF;
    opacity: 0.2;
    display:block;
    position:absolute;
    height:100px;
    width: 100vw;
    bottom:0;
    left:0;
     @media #{$desktopAndUp} {
         display:none;
     }

}

.close-mobile{
    position: absolute;
    width: 44px;
    height: 44px;
    display: block;
    background-size: 18px;
    background-position: center;
    background-repeat: no-repeat;
    top: calc(1rem + 4px);
    right: 5px;
    background-image: url('#{$dir-images}icons/close.svg');
    @media #{$desktopAndUp} {
         display:none;
    }

}

.virtual-page {
    .mobile-persona-selector,
    .menu-toggle,
    .menu {
        display: none !important;
    }

    .container--nav {
        margin-top: 16px;
    }

    .logo--main {
        top: 0 !important;
    }

    .close {
        cursor: pointer;
        height: 36px;
        width: 36px;
        position: absolute;
        top: 50%;
        right: 24px;
        transform: translateY(-50%);

        @media #{$sm} {
            right: 2.0833333333vw;
        }
    }
}

.profile-links--visible .virtual-page {
    .main-nav {
        top: 0;

        .container--nav {
            margin-top: 61px;
        }
    }
}

</style>

<style lang="scss">
    @import "../../../scss/abstracts/variables";
    @import "../../../scss/abstracts/mixins";
    $belowDesktop: $below-hd;

    .main-nav {
        .container--nav {
            .menu {
                ul {
                    li {
                        .mega-menu {
                            .menu-list {
                                .menu-link-summary {
                                    p {
                                        font-size: 12px;
                                        line-height: 22px;
                                    }

                                    p:last-child {
                                        margin: 0;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    body {
        &.profile-links--visible {
            .main-nav {
                top: 61px;
                .menu-toggle {
                    top: 61px;
                    .burger-icon{
                        margin-top:25px;

                    }
                }

                .container--nav {
                    .menu{
                        @media #{$belowDesktop} {
                            top:61px;
                        }
                        
                    }


                }
            }

            .drawer-contain,
            .views-content--colour .banner {
                margin-top: 191px;
            }

            .views-content--usecase,
            .views-content,
            .views-content--profile,
            .views-content--solution {
                margin-top: 61px;
            }
        }
    }




    li.main-menu-item {
        .underline {
            display: block;
            height: 1px;
            
            background: $brand-black;
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;

            transition: all 300ms;
            transform-origin: left;
            transform: scaleX(0);
        }

        &.with-megamenu {
            .underline {
                right: 25px;
            }
        }

        &:hover {
            .underline { 
                transform: scaleX(1);

                @media #{$belowDesktop} {
                       display:none;
                }

                
            }
        }

        .active {
            .underline { 
                transform: scaleX(1);

                  @media #{$belowDesktop} {
                       display:none;
                }
            }
        }
    }
</style>
